module.exports = __webpack_public_path__ + "img/logo-referensi.53be5e02.png";